export const IS_DEV_UI_ENABLED =
  process.env.NODE_ENV !== "production" &&
  process.env.REACT_APP_ENABLE_DEV_UI === "true";

export const IS_DEV_LOGGING_ENABLED = IS_DEV_UI_ENABLED;

export const devLog = (...args) => {
  if (IS_DEV_LOGGING_ENABLED) {
    console.log(...args);
  }
};

export const devInfo = (...args) => {
  if (IS_DEV_LOGGING_ENABLED) {
    console.info(...args);
  }
};

export const devWarn = (...args) => {
  if (IS_DEV_LOGGING_ENABLED) {
    console.warn(...args);
  }
};

export const devTable = (...args) => {
  if (IS_DEV_LOGGING_ENABLED && typeof console.table === "function") {
    console.table(...args);
  }
};

export const devError = (...args) => {
  if (IS_DEV_LOGGING_ENABLED) {
    console.error(...args);
  } else if (args.length > 0) {
    console.error(String(args[0]));
  }
};

export const DevOnly = ({ children }) => (IS_DEV_UI_ENABLED ? children : null);
